import Layout from '../../components/common/pageLayout'
import CreateForm from '../../components/NCR/newComment'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { toast } from 'react-toastify'
import { v3_create_ncr, v3_create_ncr_comment } from '../../actions/v3/ncr'

const Index = (props) => {
    const location = useLocation();
    const { shipId, ncrId } = location.state;
    const onSubmit = (model) => {
        v3_create_ncr_comment({ ...model, ncrId }).then((res) => {
            if (res.status) {
                toast.success(res.result.message)

                props.history.push({
                    pathname: constant.Authedcomponent.ncrDetail.url,
                    state: {
                        shipId,
                        ncrId
                    }
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }

    return (
        <Layout title='NCR Comment'>
            <CreateForm
                onSubmit={onSubmit}
            />
        </Layout>
    )
}

export default Index